"use strict";
// Implement astar in typescript
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPath = void 0;
function findPath(po) {
    var stepsTaken = 0;
    var openList = [];
    var closedList = [];
    var startH = po.heuristic(po.start);
    var startNode = {
        data: po.start,
        g: 0,
        h: startH,
        f: 0 + startH,
        parent: null,
    };
    openList.push(startNode);
    while (openList.length > 0) {
        // Check for timeout
        stepsTaken++;
        if (stepsTaken > po.timeoutSteps) {
            return {
                isSuccess: false,
                isTimeout: true,
                path: [],
            };
        }
        // Get the node with the lowest f score
        openList.sort(function (a, b) { return b.f - a.f; });
        var currentNode = openList.pop();
        closedList.push(currentNode);
        // console.log('openList/closedList', openList.length, closedList.length)
        // if (openList.length + closedList.length > po.timeoutSteps) {
        //   // Aggressive timeout
        //   return {
        //     isSuccess: false,
        //     isTimeout: true,
        //     path: [],
        //   }
        // }
        // Is this an end?
        // TODO: will this create bugs?
        if (currentNode.h < po.minimumH) {
            // console.log('checking for end', currentNode.h, currentNode.data)
            if (po.isEnd(currentNode.data)) {
                // Build path by unrolling parents
                var path = [];
                var node = currentNode;
                while (node.parent) {
                    path.unshift(node.data);
                    node = node.parent;
                }
                return {
                    isSuccess: true,
                    isTimeout: false,
                    path: path,
                };
            }
        }
        // Collect our neighbors (successors)
        var neighbors = po.collectNeighbors(currentNode.data);
        neighbors: for (var i = 0; i < neighbors.length; i++) {
            var neighbor = neighbors[i];
            // If successor is already in the closed list, ignore it
            for (var iClosed = 0; iClosed < closedList.length; iClosed++) {
                var closed_1 = closedList[iClosed];
                // console.log('already processed neighbor')
                if (closed_1.data === neighbor) {
                    continue neighbors; // Already processed
                }
            }
            var g = currentNode.g + 1; // TODO: add custom g? //po.distance(currentNode.data, neighbor)
            var h = po.heuristic(neighbor);
            var f = g + h;
            // If successor is already in the open list, ignore it
            for (var iOpen = 0; iOpen < openList.length; iOpen++) {
                var open_1 = openList[iOpen];
                if (open_1.data === neighbor) {
                    // console.log('already found neighbor')
                    // Already in queue to be processed
                    // Update if we have a better path
                    if (g < open_1.g) {
                        open_1.g = g;
                        open_1.h = h;
                        open_1.f = f;
                        open_1.parent = currentNode;
                    }
                    continue neighbors;
                }
            }
            openList.push({
                data: neighbor,
                g: g,
                h: h,
                f: f,
                parent: currentNode,
            });
        }
    }
    // Out of options
    return {
        isSuccess: false,
        isTimeout: false,
        path: [],
    };
}
exports.findPath = findPath;
